import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { FormControl, FormGroup, FormBuilder, Validators, FormArray, ValidatorFn } from "@angular/forms";
import { DashboardService } from "../../services/dashboard/dashboard.service";
import { CommonService } from "../../services/common/common.service"
import { DateFormatDialog } from "../export-mail/export-mail.component";
import * as moment from 'moment';

@Component({
  selector: 'schedule-dashboard-viewer',
  templateUrl: 'dashboard-schedule-dialog.component.html',
  styleUrls: ["dashboard-schedule-dialog.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class ScheduleDashboardViewerDialog implements OnInit {
  widgetListGroup: any;
  groupListForm: FormGroup;
  checkBoxGroupList: any = [];
  dashboardId: string = "";
  isPreviousCompleted = false;
  dashboardName: string = "";
  userExportPer: any;
  openSchedulerMail: boolean = false;
  minDate = moment().format();
  enumexportDType = [
    { id: "pdf", value: "PDF" },
    { id: "excel", value: "Excel" },
    { id: "csv", value: "CSV" },
  ];
  exportDType = [];
  headersContant = [
    { id: "widgetId", value: "Widget Id" },
    { id: "widgetName", value: "Widget Name" },
    { id: "kpiGroup", value: "KPI Group" },
    { id: "kpi", value: "KPI" },
    { id: "date", value: "Date" },
    { id: "dateFrom", value: "DateFrom" },
    { id: "value", value: "Value" }
  ];
  dailyA = [
    { id: "Sun", value: "Sun" },
    { id: "Mon", value: "Mon" },
    { id: "Tue", value: "Tue" },
    { id: "Wed", value: "Wed" },
    { id: "Thu", value: "Thu" },
    { id: "Fri", value: "Fri" },
    { id: "Sat", value: "Sat" }
  ];


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<ScheduleDashboardViewerDialog>,
    private dashboardService: DashboardService,
    private commonService: CommonService
  ) {
    this.widgetListGroup = data.groupListGroup;
    this.dashboardId = data.dashboardId;
    this.dashboardName = data.dashboardName;
    this.userExportPer = data.userExportPer;
    this.widgetListGroup.forEach(element => {
      this.checkBoxGroupList.push({ id: element._id, groupName: element.groupName });
    });
    this.userPermiExport();
    this.createGroupList();

  }

  ngOnInit() {

  }

  userPermiExport() {
    if (this.userExportPer.excel == "0")
      this.exportDType.push(this.enumexportDType.find((o) => o.id == "excel"));

    if (this.userExportPer.pdf == "0")
      this.exportDType.push(this.enumexportDType.find((o) => o.id == "pdf"));

    if (this.userExportPer.csv == "0")
      this.exportDType.push(this.enumexportDType.find((o) => o.id == "csv"));

  }

  createGroupList() {

    const headersControls = this.headersContant.map(c => new FormControl(true));
    const exportControls = this.exportDType.map((c) => { new FormControl(false) });
    const controls = this.checkBoxGroupList.map(c => new FormControl(true));
    const dailyControls = this.dailyA.map(c => new FormControl(false));
    this.groupListForm = this.fb.group({
      groupIdsList: this.fb.array(controls, minSelectedCheckboxes(1)),
      exportType: this.fb.array(exportControls, minSelectedCheckboxes(1)),
      to: ['', Validators.required],
      cc: [''],
      bcc: [''],
      subject: [this.dashboardName],
      reportName: [this.dashboardName],
      message: ['This is the ' + this.dashboardName, Validators.required],
      dateFormat: ['YYYY-MM-D'],
      incFltInfo: [true],
      mailBody: 'Day Offset is a negative value. It is used to generate reports being sent regularly to setup a date (date range). You setup a day to receive reports and report get generated for the date [day offset] days ago.',
      dayOffSet: ['', Validators.pattern('^[0-9]+$')],
      firstDay: [this.minDate],
      deliveryH: ['00'],
      deliveryM: [':00'],
      period: ['Weekly'],
      dailyList: this.fb.array(dailyControls)
    });
    // const groupControls = this.groupListForm.get("groupIdsList") as FormArray;
    // this.checkBoxGroupList.forEach(c => groupControls.push(new FormControl(true)));
  }

  getExportMailType() {
    return <FormArray>this.groupListForm.controls['exportType'];
  }

  getFormatDate() {
    this.dialog.open(DateFormatDialog, {
      data: {},
      height: "auto",
      width: "600px",
      panelClass: "full-modal"
    });
  }

  getGroupIds() {
    return <FormArray>this.groupListForm.controls['groupIdsList'];
  }

  onSubmit() {
    let selectedGroupIds = this.groupListForm.value.groupIdsList
      .map((v, i) => v ? this.checkBoxGroupList[i].id : null)
      .filter(v => v !== null);
    let period = this.groupListForm.get('period').value;
    let requestForm = {
      "dashboardId": this.dashboardId,
      "groupIds": selectedGroupIds.join(','),
      //"groupIds": this.groupIds,
      "exportType": this.dailyHeadersVal(this.groupListForm.value.exportType, this.exportDType, false),//this.exportSchedulerMailForm.get('exportType').value,
      "reportName": this.groupListForm.get('reportName').value,
      "emailTo": this.groupListForm.get('to').value,
      "emailCC": this.groupListForm.get('cc').value,
      "emailBCC": this.groupListForm.get('bcc').value,
      "emailSubject": this.groupListForm.get('subject').value,
      "emailBody": this.groupListForm.get('message').value,//this.exportSchedulerMailForm.get('mailBody').value,
      "firstDay": moment(this.groupListForm.get('firstDay').value).format("YYYY-MM-DD"),
      "emailTime": this.groupListForm.get('deliveryH').value + this.groupListForm.get('deliveryM').value,
      "dayOffset": this.groupListForm.get('dayOffSet').value,
      "period": period,
      "dateFormat": this.groupListForm.get('dateFormat').value,
      "days": period == "Daily" ? this.dailyHeadersVal(this.groupListForm.value.dailyList, this.dailyA, true) : "",
      "includeFilterInfo": (this.groupListForm.get('incFltInfo').value == true ? 1 : 0),
    };
    if (this.groupListForm.valid) {
      this.dashboardService.requestMail("scheduler/AddSchedule", requestForm).subscribe((res) => {
        this.commonService.openSnackBar("Mail scheduled", "");
        this.dialog.closeAll();
      }, (err) => {
        console.log(err);
        this.commonService.openSnackBar("Failed while mailing", "");        
      });
    }

    //this.exportDocument(this.groupListForm.get('exportType').value, groupId)

  }

  dailyHeadersVal(formCValue, arrayLis, isDay) {

    let selectedHeaders = formCValue//this.exportSchedulerMailForm.value.dailyList
      .map((v, i) => v ? arrayLis[i].id : null)//this.dailyA[i].id : null)
      .filter(v => v !== null);

    if (isDay)
      //if it's daily and user has not selected any specific day pass all days
      selectedHeaders = selectedHeaders.length == 0 ? arrayLis.map((obj) => { return obj.id }) : selectedHeaders;
    return selectedHeaders;

  }

  HeadersVal(url): string {
    let selectedHeaders = this.groupListForm.value.headersList
      .map((v, i) => v ? this.headersContant[i].id : null)
      .filter(v => v !== null);    
    url += "&selectedh=" + selectedHeaders;
    return url;
  }

}
function minSelectedCheckboxes(min = 1) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      // get a list of checkbox values (boolean)
      .map(control => control.value)
      // total up the number of checked checkboxes
      .reduce((prev, next) => next ? prev + next : prev, 0);

    // if the total is not greater than the minimum, return the error message
    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/export/dashboardschedule/dashboard-schedule-dialog.component.ts